import React, { FC }             from "react";
import { useDispatch, useStore } from "react-redux";
import { Button, Icon }          from "semantic-ui-react";
import SaveRecordTemplate        from "../../../../application/usecase/record/template/SaveRecordTemplate";
import RecordTemplate            from "../../../../domain/record/template/RecordTemplate";

const RecordTemplateSaveButton: FC = () => {
  const saveRecordTemplate: SaveRecordTemplate = new SaveRecordTemplate(useDispatch());
  const template: RecordTemplate = useStore().getState().template;
  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => saveRecordTemplate.execute(template) }
      >
        <Icon name="save"/>保存する
      </Button>
    </>
  );
};

export default RecordTemplateSaveButton;
